/**
 * @surfline/quiver-react v12.14.9 2020-10-22
 */

import React from 'react';
import 'prop-types';
import classNames from 'classnames';
import SurfConditions from '../SurfConditions/SurfConditions.js';
import PremiumCamIconMedium from '../icons/PremiumCamIconMedium/PremiumCamIconMedium.js';
import checkConditionValue from '../utils/checkConditionValue.js';

const getThumbnailClassName = isTooltip => classNames({
  'quiver-spot-list-cta-thumbnail': true,
  'quiver-spot-list-cta-thumbnail--tooltip': isTooltip
});

const SpotListCTAThumbnail = ({
  spot,
  isTooltip
}) => /*#__PURE__*/React.createElement("div", {
  className: getThumbnailClassName(isTooltip)
}, /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-list-cta-thumbnail__indicator"
}, /*#__PURE__*/React.createElement(PremiumCamIconMedium, null)), /*#__PURE__*/React.createElement("div", {
  className: "quiver-spot-list-cta-thumbnail__spot-details"
}, /*#__PURE__*/React.createElement("h3", {
  className: "quiver-spot-list-cta-thumbnail__spot-details__name"
}, spot.name), /*#__PURE__*/React.createElement(SurfConditions, {
  conditions: checkConditionValue(spot.conditions.value),
  expired: spot.conditions.expired && spot.conditions.human
})));

SpotListCTAThumbnail.defaultProps = {
  isTooltip: false
};

export default SpotListCTAThumbnail;
//# sourceMappingURL=SpotListCTAThumbnail.js.map
